import "./full.css"
function Full(){
    return(
        <div className="full-main">
            <div className="container-full">
            </div>
            <div className="container-name">
            <h2 className="full-head">Gallery</h2>
            </div>

        </div>
    )
}
export default Full;